import React from 'react';
import { useId } from '@mantine/hooks';
import {
  Card,
  Text,
  Image,
  Box,
  Group,
  Stack,
  Container,
  Title,
  ScrollArea,
  useMantineTheme,
} from '@mantine/core';
import Link from './Link';

function HomePageTestimonials() {

  const { colors } = useMantineTheme();
  const highlightColor = colors.violet[8];

  const IMAGE_SIZE = 80;

  const testimonials = [
    {
      key: useId(),
      body: 'This app has been a game changer (pun intended) for me as a small business owner, making my events easier to prep for while being sleek & simple to navigate!',
      author: 'Becca N',
      instagram: 'beccahosts',
      image: 'becca.png',
    },
    {
      key: useId(),
      body: 'Preparing cards for pub nights can be stressful and difficult, but the Twiz app has made it SUPER easy and quick! I love the variety of fonts and icons to personalize each game.',
      author: 'Joey C',
      instagram: 'unclejoeyy',
      image: 'joey.png',
    },
    {
      key: useId(),
      body: 'The Twiz app has been amazing for me as a host! It’s incredibly user friendly, completely customizable and is able to generate hundreds of cards in a matter of seconds.',
      author: 'Dani C',
      instagram: 'pandaproblems',
      image: 'dani.png',
    },
  ];

  // The Twiz app has been amazing for me as a host! The support team was incredible with any questions that I had and were quick to get back to me. It’s incredibly user friendly, completely customizable and is able to generate 200 double cards in a matter of seconds! Super happy with the app and my experience as a customer. 

  const getTestimonial = (testimonial) => {
    const {
      key,
      body,
      author,
      image,
      instagram,
    } = testimonial;

    return ( 
      <Card
        key={key}
        shadow='lg'
        radius='md'
        px={{ base: 'lg', md: 'xl' }}
        py={{ base: 'xl', md: 32 }}
        w={256}
        miw={256}
      >
        <Stack spacing='md' justify='space-between' h='100%'>
          <Stack spacing='md'>
            <Box
              h={IMAGE_SIZE}
              w={IMAGE_SIZE}
              sx={(theme) => ({
                borderRadius: '50%',
                backgroundColor: theme.colors.violet[0]
              })}
            >
              <Image
                width='auto'
                ml={-8}
                src={`https://music-bingo.s3.us-east-1.amazonaws.com/${image}`}
                height={IMAGE_SIZE}
                alt={`Image of ${author}`}
              /> 
            </Box>
            <Text color='gray.7' lh='150%'>
              &ldquo;
              {body}
              &rdquo;
            </Text>
          </Stack>

          <Link
            href={`https://www.instagram.com/${instagram}`}
            anchorProps={{
              c: 'gray.6',
              size: 'sm',
            }}
            newTab
          >
            {author}
          </Link>
        </Stack>
      </Card>
    )
  };

  return (
    <Box>
      <Container px='xl' pb={0}>
        <Title size='h3' order={2} mt='md' mb='xs'>
          Games your audience will <span style={{ color: highlightColor }}>love</span>
        </Title>
        <Text color='gray.7' mb={32}>
          From weekly bingo nights to team building events, and everything in between.
        </Text>
      </Container>
      <Container p={0}>
        <ScrollArea>
          <Group grow spacing='lg' align='stretch' w='100%' noWrap px='xl' pb={80}>
            {testimonials.map((testimonial) => getTestimonial(testimonial) )}
          </Group>
        </ScrollArea>
      </Container>
    </Box>
  );
}

export default HomePageTestimonials;